import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { PreviewSnippetDrawerComponent } from "./PreviewSnippetDrawerComponent";

const PreviewSnippetDrawer = ModalManager.create(
  ({ snippetId }: { snippetId: number }) => (
    <PreviewSnippetDrawerComponent id={snippetId} />
  ),
);

export const usePreviewSnippetDrawer = () => useModal(PreviewSnippetDrawer);
